/*
 * Views for individual category
 */

define(["marionette", "./template/categoryTemplate.html"], function (Marionette, CategoryTemplate) {
  var CategoryView = {};

  CategoryView.categoryLayout = Marionette.Layout.extend({
    template: CategoryTemplate,
    regions: {
      categoryValues: "#categoryValues",
      categoryInfo: "#categoryInfo",
    },
  });

  return CategoryView;
});
